declare global {
	interface Window {
		clarity: any;
	}
}

const useClarityEvent = () => {
	const trackEvent = (eventName: string) => {
		try {
			if (window.clarity) {
				window.clarity('event', eventName);
			}
		} catch (error) {}
	};

	return {
		trackEvent,
	};
};

export default useClarityEvent;
